import { gql } from 'react-apollo';

export default gql`
  query allOffersAnon($query: QueryInput!, $tenantId: ID!) {
    allOffersAnon(query: $query, tenantId: $tenantId) {
      _id
      items {
        _id
        status
        tombstoneImageUrl
        offerPresentationTitle
        offerPresentationUrl
        enableOfferPresentation
        stripeAccountId
        stripeProductId
        listingType
        investmentInstrument
        area
        sector
        repName
        crdNumber
        minimumInvestment
        targetRaise
        offerCurrency
        valueRange
        offerPassword
        typeOfOffer
        assetStatus
        sharesForSale
        headerType
        headerVideoId
        primaryObjective
        netAcres
        county
        averageDailyProduction
        baseCurrency
        geographicMandate
        fundType
        domicileOption
        domicileOnshore
        domicileOnshoreFund_other
        domicileOffShore
        domicileOffShore_other
        systematicDiscretionaryOption
        investmentCoActExemptionOption
        investmentAdvisorType
        leverage
        fundStructure
        fundStrategyClassfication
        fundStrategyClassficationOne
        fundStrategyClassficationTwo
        fundStrategyClassficationThree
        aumfund
        fundCapacity
        trackRecordFund
        trackRecordFirm
        openedAt
        tenantId
        toggleDataRoom
        altOfferTitle
        productDeveloper
        creditIssued
        product
        vintage
        region
        tenant {
          _id
          name
          domainPrefix
          customDomain
        }
        sharedTenants {
          tenantId
          published
        }

        issuerCompany {
          _id
          name
          isCompanyApproved
          users {
            _id
            isManagementUserApproved
          }
        }
      }
      total
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/allOffersAnon.js